// eslint-disable-next-line import/prefer-default-export
export const clearOrderCreateStore = async (ctx) => {
  sessionStorage.removeItem(`${ctx}.orderUuid`);
  sessionStorage.removeItem(`${ctx}.referrer`);
  sessionStorage.removeItem(`${ctx}.formData`);
  sessionStorage.removeItem(`${ctx}.selectedTariffs`);
  sessionStorage.removeItem(`${ctx}.customFields`);
  sessionStorage.removeItem(`${ctx}.customFieldRequiredBySource`);
  sessionStorage.removeItem(`${ctx}.canContinueAsLead`);
  sessionStorage.removeItem(`${ctx}.calculatorFormData`);
  sessionStorage.removeItem(`${ctx}.existingCustomerData`);
  sessionStorage.removeItem(`${ctx}.calculatorSelectedTariffs`);
  sessionStorage.removeItem(`${ctx}.calculatorStreets`);
  sessionStorage.removeItem(`${ctx}.categories`);
  sessionStorage.removeItem(`${ctx}.accessibleSteps`);
  sessionStorage.removeItem(`${ctx}.calculatorPostcodeStreetsRequired`);
  sessionStorage.removeItem(`${ctx}.contractData`);
  sessionStorage.removeItem(`${ctx}.currentContractTariff`);
  sessionStorage.removeItem(`${ctx}.initialPrefilledFields`);
  sessionStorage.removeItem(`${ctx}.relocationAddress`);
  sessionStorage.removeItem(`${ctx}.relocationPriceData`);
  sessionStorage.removeItem(`${ctx}.preparedDataAddress`);
  sessionStorage.removeItem(`${ctx}.orderMode`);
  sessionStorage.removeItem(`${ctx}.ordersCreate.calculatorSelectedBonuses`);
  sessionStorage.removeItem(`${ctx}.ordersCreate.calculatorUpdatedPrices`);
  sessionStorage.removeItem(`${ctx}.calculatorTransitionTariffs`);
  sessionStorage.removeItem(`${ctx}.isDynamicPower`);
  sessionStorage.removeItem(`${ctx}.overviewInputFlags`);

  // Clear localStorage step update flags
  const context = ctx.match(/([a-z]\w+)[A-Z]/)?.[1];
  ['create', 'edit'].forEach((type) => {
    localStorage.removeItem(`route_meta_${context}-${type}-address`);
    localStorage.removeItem(`route_meta_${context}-${type}-consumption`);
    localStorage.removeItem(`route_meta_${context}-${type}-payment`);
    localStorage.removeItem(`route_meta_${context}-${type}-custom-fields`);
  });

  localStorage.removeItem('customerNumber');
};

export const clearProductsPriceCalculationStore = () => {
  sessionStorage.removeItem('productsPriceCalculation.formData');
  sessionStorage.removeItem('productsPriceCalculation.accessibleSteps');
  sessionStorage.removeItem('productsPriceCalculation.currentStep');
};
